import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export type AccessFailureKind =
  | 'get_user_failed'
  | 'profile_load_failed'
  | 'dashboard_load_timeout'
  | 'dashboard_data_failed'
  | 'firebase_config_mismatch'
  | 'login_network_failed'
  | 'login_auth_error';

const CLIENT_DEDUP_MS = 60 * 60 * 1000;
const SESSION_DEDUP_KEY = 'prairi_access_failure_reported';

function shouldReportFromClient(kind: AccessFailureKind): boolean {
  try {
    const raw = sessionStorage.getItem(SESSION_DEDUP_KEY);
    const seen = raw ? (JSON.parse(raw) as Record<string, number>) : {};
    const now = Date.now();
    if (seen[kind] && now - seen[kind] < CLIENT_DEDUP_MS) return false;
    seen[kind] = now;
    sessionStorage.setItem(SESSION_DEDUP_KEY, JSON.stringify(seen));
    return true;
  } catch {
    return true;
  }
}

/** Fire-and-forget admin alert for critical post-login access failures. */
export function reportAccessFailure(params: {
  kind: AccessFailureKind;
  route: string;
  message?: string;
}): void {
  if (!shouldReportFromClient(params.kind)) return;

  const reportFn = httpsCallable(functions, 'reportAccessFailure');
  void reportFn({
    kind: params.kind,
    route: params.route,
    message: params.message?.slice(0, 500),
  }).catch(err => {
    console.error('[AccessFailure] Failed to report:', err);
  });
}
